import React from 'react';
import { heroData, ctaLink, logoUrl } from '../data/mock';

const HeroSection = () => {
  const handleCTAClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Subscribe');
    }
  };

  return (
    <section className="bg-[#FF6699] min-h-screen relative overflow-hidden pt-[50px] pb-[50px] px-[25px] md:pt-[75px] md:pb-[75px] md:px-[75px] lg:pt-[100px] lg:pb-[100px] lg:px-[100px]">
      {/* Logo */}
      <div className="pb-8 flex justify-center">
        <img 
          src={logoUrl} 
          alt="Fira Indicator" 
          className="h-10 md:h-12 w-auto object-contain"
        />
      </div>

      {/* Hero Content */}
      <div className="max-w-5xl mx-auto text-center relative">
        {/* Fira Image - CROP version */}
        <div className="relative mb-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_618cd302-26c2-4845-b940-fc1c769b2643/artifacts/a6ecf8yd_FIRA%20TAPAK%200-CROP.png"
            alt="Fira"
            className="w-[95%] md:w-[85%] lg:w-[75%] max-w-[750px] mx-auto object-contain relative z-10"
          />
        </div>

        {/* Main Title - Overlaps only with image, not subheadline */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-[#F8F8F8] mb-8 animate-fade-in-up tracking-tight leading-tight relative z-30 -mt-20 md:-mt-28 lg:-mt-36">
          {heroData.title}
        </h1>

        {/* Subtitle lines - No overlap */}
        <div className="space-y-4 mb-12 relative z-30">
          {heroData.subtitle.map((line, index) => (
            <p 
              key={index}
              className="text-lg md:text-xl lg:text-2xl text-[#191919]/80 font-normal animate-fade-in-up"
              style={{ animationDelay: `${(index + 1) * 0.2}s` }}
            >
              {line}
            </p>
          ))}
        </div>

        {/* CTA Button */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.8s' }}>
          <a
            href={ctaLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleCTAClick}
            className="inline-block bg-[#33CCCC] hover:bg-[#2ab8b8] text-[#191919] font-bold text-lg md:text-xl px-10 py-4 rounded-full transition-all duration-300 transform hover:scale-105 animate-pulse-glow"
          >
            Claim Access Percuma
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
